<template>
  <header>

    <div class="top-nav">
      <div class="d-flex justify-content-between">
        <div class="lang">
          <button v-if="$i18n.locale == 'ar'" @click="onChange('en'); activeMobile = false">
            <a>English</a>
          </button>
          <button v-if="$i18n.locale == 'en'" @click="onChange('ar'); activeMobile = false">
            <a>عربي</a>
          </button>
        </div>

        <div class="country_select_div">
          <select v-model="country" @change="change_country" id="country"
            class="form-control form-select select_country">
            <option v-for="(item, index) in this.countries" :value="item.id">{{ item.unit }} | {{ item.name }}</option>
          </select>
        </div>


      </div>
    </div>


    <nav class="second_section_header">
      <div class="d-flex justify-content-between first_nav">

        <div class="search_section">
          <i class="bi bi-search" @click="show_search = true" style="font-size: 20px;"></i>
          <router-link class="show_mobile" :to="{
            name: 'shoppingCart',
            params: { storeName: this.$store.storeName, lang: $i18n.locale },
          }">
            <i class="bi bi-handbag" style="font-size: 1.5rem; margin-left: 15px;"></i>
            <span class="cart_counter" style="float: right;"> {{ this.$store.state.cartCounter }}</span>
          </router-link>

        </div>



        <div class="logo_section">
          <img :src="this.$store.state.logo" alt="Logo" class="logo" />
        </div>


        <div class="d-flex justify-content-between  show_disk">

          <select v-model="country" @change="change_country" id="country"
            class="form-control form-select select_country">
            <option v-for="(item, index) in this.countries" :value="item.id">{{ item.unit }} | {{ item.name }}</option>
          </select>

          <router-link v-if="this.$localStorage.get(this.$store.storeName) == null" :to="{
            name: 'login',
            params: { storeName: this.$store.storeName, lang: $i18n.locale },
          }" class="lgin_btn_header">
            <i class="bi bi-person" style="font-size: 1.5rem; margin-left: 15px;"></i>
          </router-link>

          <b-dropdown v-else size="lg" variant="link" toggle-class="text-decoration-none" no-caret>
            <template #button-content>

              <i class="bi bi-person" style="font-size: 1.5rem; margin-left: 15px;"></i>

            </template>
            <b-dropdown-item id="user_account">


              <router-link style="display:block" :to="{
                name: 'myOrders',
                params: { storeName: this.$store.storeName, lang: $store.state.routeLang },
              }"
                class="flex items-center font-medium py-2 px-4 dark:text-white/70 hover:text-orange-500 dark:hover:text-white">
                {{ $t('myOrders') }}</router-link>
                <router-link style="display:block" :to="{
                name: 'myAddresses',
                params: { storeName: this.$store.storeName, lang: $store.state.routeLang },
              }"
                class="flex items-center font-medium py-2 px-4 dark:text-white/70 hover:text-orange-500 dark:hover:text-white">
                {{ $t('myAddresses') }}</router-link>

              <router-link style="display:block" :to="{
                name: 'notifications',
                params: { storeName: this.$store.storeName, lang: $store.state.routeLang },
              }" class="flex items-center font-medium
                                                  py-2 px-4 dark:text-white/70 hover:text-orange-500
                                                   dark:hover:text-white">
                {{ $t('Notifications') }}</router-link>


              <a @click="show = true" class="flex items-center font-medium py-2 
                                    px-4 dark:text-white/70 hover:text-orange-500 dark:hover:text-white">
                {{ $t('logout') }}</a>




            </b-dropdown-item>

          </b-dropdown>

          <router-link :to="{
            name: 'shoppingCart',
            params: { storeName: this.$store.storeName, lang: $i18n.locale },
          }">
            <span class="cart_counter" style="float: right;"> {{ this.$store.state.cartCounter }}</span>
            <i class="bi bi-handbag" style="font-size: 1.5rem; margin-left: 15px;"></i> </router-link>



        </div>

        <i :class="'show_mobile bi bi-list mobile-nav-toggle ' + (activeMobile ? ' bi-x' : '')
          " @click="activeMobile = !activeMobile"></i>
      </div>

      <!--  -->
      <div class="nav_desk">
        <ul class="nav_menue">
          <li @click="activeMobile = false" class="active_home">
            <router-link :to="{
              name: 'home1',
              params: { storeName: this.$store.storeName, lang: $i18n.locale },
            }">{{ $t("home") }}</router-link>
          </li>
<!-- 
          <li @click="activeMobile = false">
            <router-link :to="{
              name: 'about',
              params: { storeName: this.$store.storeName, lang: $i18n.locale },
            }">{{ $t("about") }}</router-link>
          </li> -->
          
          <li class="mobile-inactive">
            <b-dropdown :text='$t("All colleactions")' class="">
              <b-dropdown-item>

                <router-link :to="{
                  name: 'sections',
                  params: { storeName: this.$store.storeName, lang: $i18n.locale },
                }">
                  {{ $t("sections") }}</router-link>
              </b-dropdown-item>
              <b-dropdown-item v-for="(item, index) in headerSections" :key="index">

                <router-link style="display:block" :to="{
                  name: 'section',
                  params: {
                    storeName: $store.storeName,
                    id: item.id,
                    name: item.name,
                  },
                }">

                  {{ item.name }}
                </router-link>
              </b-dropdown-item>

            </b-dropdown>
          </li>
<!--  -->
<li class="mobile-inactive">
            <b-dropdown :text='$t("policies")' class="policies_header">

              <b-dropdown-item>

<router-link :to="{
 name: 'privacy',
 params: { storeName: this.$store.storeName, lang: $i18n.locale },
}">{{ $t("privacyPolicy") }}</router-link>

 </b-dropdown-item>
              <b-dropdown-item>
             <router-link :to="{
              name: 'refund_policy',
              params: { storeName: this.$store.storeName, lang: $i18n.locale },
            }">{{$t("privacy1") }}</router-link>

              </b-dropdown-item>

            <b-dropdown-item>

            <router-link :to="{
              name: 'shipping_police',
              params: { storeName: this.$store.storeName, lang: $i18n.locale },
            }">{{ $t("privacy2") }}</router-link>
          
              </b-dropdown-item>
             

            </b-dropdown>
          </li>
<!--  -->
        

          <li @click="activeMobile = false">
            <router-link :to="{
              name: 'support',
              params: { storeName: this.$store.storeName, lang: $i18n.locale },
            }">{{ $t("support") }}</router-link>
          </li>
          <li @click="activeMobile = false" class="sizes_router">
            <router-link :to="{
              name: 'sizes',
              params: { storeName: this.$store.storeName, lang: $i18n.locale },
            }">{{ $t("sizes") }}</router-link>
          </li>

          <!-- <li @click="activeMobile = false">
            <router-link :to="{
              name: 'contactUs',
              params: { storeName: this.$store.storeName, lang: $i18n.locale },
            }">{{ $t("contactUs") }}</router-link>
          </li> -->


        </ul>
      </div>
      <!--  -->

      <div class="nav_mobile" v-if="activeMobile">
        <ul class="nav_menue">
          <li @click="activeMobile = false" class="active_home">
            <router-link :to="{
              name: 'home1',
              params: { storeName: this.$store.storeName, lang: $i18n.locale },
            }">{{ $t("home") }}</router-link>
          </li>

          <li @click="activeMobile = false">
            <router-link :to="{
              name: 'sizes',
              params: { storeName: this.$store.storeName, lang: $i18n.locale },
            }">{{ $t("sizes") }}</router-link>
          </li>

          <li @click="activeMobile = false; activeSection = true">
            <div class="d-flex justify-content-between">
              <p>{{ $t('All colleactions') }}</p>
              <i class="bi bi-arrow-right" @click="activeMobile = false; activeSection = true"></i>
            </div>
          </li>

          <li @click="activeMobile = false; activePrivacy = true">
            <div class="d-flex justify-content-between">
              <p> {{ $t('policies') }}</p>
              <i class="bi bi-arrow-right" @click="activeMobile = false; activePrivacy = true"></i>
            </div>


          </li>

          <li @click="activeMobile = false" class="mobile-active"
            v-if="this.$localStorage.get(this.$store.storeName) != null">
            <router-link :to="{
              name: 'profile',
              params: { storeName: this.$store.storeName, lang: $i18n.locale },
            }">{{ $t("profile") }}</router-link>
          </li>
          <li @click="activeMobile = false" class="mobile-active"
            v-if="this.$localStorage.get(this.$store.storeName) != null">
            <router-link :to="{
              name: 'myOrders',
              params: { storeName: this.$store.storeName, lang: $i18n.locale },
            }">{{ $t("myOrders") }}</router-link>
          </li>
          <li @click="activeMobile = false" class="mobile-active"
            v-if="this.$localStorage.get(this.$store.storeName) != null">
            <router-link :to="{
              name: 'myAddresses',
              params: { storeName: this.$store.storeName, lang: $i18n.locale },
            }">{{ $t("myAddresses") }}</router-link>
          </li>
          <li @click="activeMobile = false" class="mobile-active"
            v-if="this.$localStorage.get(this.$store.storeName) != null">
            <router-link :to="{
              name: 'favorites',
              params: { storeName: this.$store.storeName, lang: $i18n.locale },
            }">{{ $t("favorites") }}</router-link>
          </li>
          <li v-if="this.countries > 1">
            <select v-model="country" @change="change_country" id="country" class="form-control select_country">
              <option v-for="(item, index) in this.countries" :value="item.id">{{ item.name }}</option>
            </select>
          </li>

          <!-- <li @click="activeMobile = false">
            <router-link :to="{
              name: 'contactUs',
              params: { storeName: this.$store.storeName, lang: $i18n.locale },
            }">{{ $t("contactUs") }}</router-link>
          </li> -->

          <li @click="activeMobile = false">
            <router-link :to="{
              name: 'support',
              params: { storeName: this.$store.storeName, lang: $i18n.locale },
            }">{{ $t("support") }}</router-link>
          </li>

          <li @click="activeMobile = false">
            <router-link v-if="this.$localStorage.get(this.$store.storeName) == null" :to="{
              name: 'login',
              params: { storeName: this.$store.storeName, lang: $i18n.locale },
            }" class="lgin_btn_header">
              {{ $t('login') }}
            </router-link>
          </li>

          <li @click="activeMobile = false; show = true" v-if="this.$localStorage.get(this.$store.storeName) != null">
            <a @click="show = true" class="flex items-center font-medium py-2 
                                    px-4 dark:text-white/70 hover:text-orange-500 dark:hover:text-white">
              {{ $t('logout') }}</a>
          </li>

          <li class="country_mobiles">
            <select v-model="country" @change="change_country" id="country"
            class="form-control form-select select_country">
            <option v-for="(item, index) in this.countries" :value="item.id">{{ item.unit }} | {{ item.name }}</option>
          </select>

          </li>

        </ul>
      </div>


      <div class="nav_mobile " v-if="activeSection">
        <ul class="nav_menue">

          <li @click="activeMobile = true; activeSection = false" class="active_home">
            <i class="bi bi-arrow-left	" @click="activeMobile = false; activeSection = true"></i>

            {{ $t('All colleactions') }}

          </li>

          <li @click="activeMobile = false; activeSection = false">
            <router-link :to="{
              name: 'sections',
              params: {
                storeName: $store.storeName,
                lang: $i18n.locale
              },
            }">

              {{ $t('All') }}
            </router-link>
          </li>

          <li @click="activeMobile = false; activeSection = false" v-for="(item, index) in headerSections" :key="index">
            <router-link :to="{
              name: 'section',
              params: {
                storeName: $store.storeName,
                id: item.id,
                name: item.name,
                lang: $i18n.locale
              },
            }">
              {{ item.name }}
            </router-link>
          </li>

        </ul>
      </div>


      <div class="nav_mobile " v-if="activePrivacy">
        <ul class="nav_menue">
          <li @click="activeMobile = true; activePrivacy = false" class="active_home">
            <i class="bi bi-arrow-left" @click="activeMobile = true; activePrivacy = false"></i>

            {{ $t('policies') }}
          </li>
          <li @click="activeMobile = false; activePrivacy = false">
            <router-link :to="{
              name: 'privacy',
              params: { storeName: this.$store.storeName, lang: $i18n.locale },
            }">{{ $t("privacyPolicy") }}</router-link>
          </li>

          <li @click="activeMobile = false; activePrivacy = false">
            <router-link :to="{
              name: 'refund_policy',
              params: { storeName: this.$store.storeName, lang: $i18n.locale },
            }">{{ $t("privacy1") }}</router-link>
          </li>

          <li @click="activeMobile = false; activePrivacy = false">
            <router-link :to="{
              name: 'shipping_police',
              params: { storeName: this.$store.storeName, lang: $i18n.locale },
            }">{{$t("privacy2") }}</router-link>
          </li>

        </ul>
      </div>

    </nav>
    <Transition name="modal">
    

      <div v-if="show_search" class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
            <div class="modal-header">
            </div>
            <input class="h-9 px-3 pe-10 w-full 
                               border-0 focus:ring-0 outline-none
                                bg-white dark:bg-slate-900 shadow dark:shadow-gray-800" :placeholder="$t('Search...')"
              id="search-input" autocomplete="false" onblur="this.setAttribute('readonly', 'readonly') , word=''"
              onfocus="this.removeAttribute('readonly');" :aria-label="$t('search')" aria-describedby="search-addon"
              type="text" v-model="word" @keyup.enter="searchRoute">
            <p @click="show_search = false" style="font-size: 24px;">X</p>
          </div>
        </div>
      </div>

    </Transition>

    <Transition name="modal">
      <div v-if="show" class="search_section_div">
        <div class="modal-wrapper">
          <div class="modal-container">
            <div class="modal-header">
              <slot name="header">{{ $t("confirmdeleteAllNoti") }}</slot>
            </div>
            <div class="modal-footer">
              <slot name="footer">
                <button class="modal-default-button" @click="deleteAll()">{{ $t("confirm") }}</button>
                <button class="modal-default-button" @click="(show = false), $emit('close')">{{ $t("cancel") }}</button>
              </slot>
            </div>
          </div>
        </div>
      </div>
      <div v-if="show1" class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
            <div class="modal-header">
              <slot name="header">{{ $t("confirmdeleteOneNoti") }}</slot>
            </div>
            <div class="modal-footer">
              <slot name="footer">
                <button class="modal-default-button" @click="deleteOneNote()">{{ $t("confirm") }}</button>
                <button class="modal-default-button" @click="(show1 = false), $emit('close')">{{ $t("cancel")
                  }}</button>
              </slot>
            </div>
          </div>
        </div>
      </div>

      <div v-if="show2" class="modal-mask logout_form">
        <div class="modal-wrapper">
          <div class="modal-container">
            <div class="modal-header">
              <slot name="header">{{ $t("confirmlogout") }}</slot>
            </div>
            <div class="modal-footer">
              <slot name="footer">
                <button class="modal-default-button" @click="logOut()">{{ $t("confirm") }}</button>
                <button class="modal-default-button" @click="(show2 = false), $emit('close')">{{ $t("cancel")
                  }}</button>
              </slot>
            </div>
          </div>
        </div>
      </div>
    </Transition>

  </header>
</template>

<script>
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'
export default {
  // eslint-disable-next-line
  /*eslint-disable */
  name: "Header",
  props: {
    // name: String,
    // image: String
    storeName: String,
  },
  data: function () {
    return {
      
      loading: false,
      loadingNote: false,
      activeMobile: false,
      word: "",
      show: false,
      show1: false,
      show2: false,
      deleteNoteId: null,
      deleteNoteIndex: null,
      notifications: [],
      headerSections: null,
      loginVodal: false,
      country: 6,
      countries: [],
      show_search: false,
      activePrivacy: false,
      activeSection: false,
      langChange: ""
    };
  },
  computed: {
    myState: function () {
      return this.$store.state.notificationUpdate; // return the state value in `my_state`
    },
  },
  watch: {
    myState: function (newVal, oldVal) {
      console.log(this.$store.notificationUpdate + " hiiiiiiiiiiii ");
      if (this.$localStorage.get(this.$store.storeName) != null) {
        this.loadingNote = true;
        this.axios
          .get(
            this.$store.state.base_api_url +
            this.$store.storeName +
            "/new_note",
            {
              headers: {
                "Accept-Language": this.$i18n.locale,
                Authorization:
                  "Bearer " + this.$localStorage.get(this.$store.storeName),
              },
            }
          )
          .then((response) => {
            if (response.data.data.code == "1") {
              this.notifications = response.data.data.notes;
              console.log("heeeeeeeeeeeeeeeeeeee " + this.notifications);
            }
          })
          .then(() => {
            this.loadingNote = false;
          });
      }

    },
    langChange() {
      {
        this.loading = true;
        this.axios
          .get(
            this.$store.state.base_api_url +
            this.$store.storeName +
            "/sections_theme2",
            {
              headers: {
                "Accept-Language": this.$i18n.locale,
              },
            }
          )
          .then((response) => {
            this.headerSections = response.data.data;
          })
          .then(() => (this.loading = false));


        this.axios
          .get(
            this.$store.state.base_api_url + this.$store.storeName + "/market_countries",
            {
              headers: {
                "Accept-Language": this.$i18n.locale
              }
            }
          )
          .then(response => {
            this.countries = response.data.data;
          })

          .then(() => (this.loading = false));
      }
    },


  },
  updated() {
    this.langChange = this.$i18n.locale

  },
  created() {
    if (this.$route.params.lang && this.$route.params.lang != this.$i18n.locale) {
      this.$i18n.locale = this.$route.params.lang;
      this.$store.state.UnitPrice = this.$store.state.unitAR
      if (this.$i18n.locale == 'en') {
        document.documentElement.setAttribute("dir", "ltr");
        let h = document.querySelector('body');
        this.$store.state.UnitPrice = this.$store.state.unit
      }
    }

    /////////////
    this.axios
      .get(
        this.$store.state.base_api_url + this.$store.storeName + "/market_countries",
        {
          headers: {
            "Accept-Language": this.$i18n.locale
          }
        }
      )
      .then(response => {
        this.countries = response.data.data;
        console.log('gggg', this.countries)

      })
      .then(() => (this.loading = false));
    ////////////////
    this.loading = true;
    this.axios
      .get(
        this.$store.state.base_api_url +
        this.$store.storeName +
        "/sections_theme2",
        {
          headers: {
            "Accept-Language": this.$i18n.locale,
          },
        }
      )
      .then((response) => {
        this.headerSections = response.data.data;
      })
      .then(() => (this.loading = false));

    if (this.$localStorage.get(this.$store.storeName) != null) {
      this.loadingNote = true;
      this.axios
        .get(
          this.$store.state.base_api_url + this.$store.storeName + "/new_note",
          {
            headers: {
              "Accept-Language": this.$i18n.locale,
              Authorization:
                "Bearer " + this.$localStorage.get(this.$store.storeName),
            },
          }
        )
        .then((response) => {
          if (response.data.data.code == "1") {
            this.notifications = response.data.data.notes;
            //console.log(this.notifications);
          }
        })
        .then(() => {
          this.loadingNote = false;
        });
    }
    let AllCookies = this.$cookies.keys();
    let counter = 0;
    for (let i = 0; i < AllCookies.length; i++) {
      if (AllCookies[i].split("/")[0] == this.$store.storeName) {
        counter++;
        //console.log(this.items);
      }
    }
    this.$store.state.cartCounter = counter;
    console.log(counter);

    console.log('countries****', this.countries)
  },
  methods: {
    change_country() {
      //////////////////////////
      console.log('///////////////////////////////////////////////////////////////////////////////////')
      console.log(this.country)
      this.axios
        .get(
          this.$store.state.base_api_url + this.$store.storeName + "/currencyv1/" + this.country,
          {
            headers: {
              "Accept-Language": this.$i18n.locale
            }
          }
        )
        .then(response => {
          this.$store.state.rate = response.data.data.rate
          this.$store.state.unit = response.data.data.unit_en
          this.$store.state.unitAR = response.data.data.unit_ar
          this.$store.state.country_code = response.data.data.country_code;
          this.$store.state.country_flag = response.data.data.country_flag;
          this.$store.state.country_length = response.data.data.country_length;
          if (this.$i18n.locale == 'ar') {
            this.$store.state.UnitPrice = this.$store.state.unitAR;
          }
          else {
            this.$store.state.UnitPrice = this.$store.state.unit;
          }

        })
        .then(() => (this.loading = false));


      ///////////////////////////////
    },

    onChange(lang) {
      this.$store.state.langchange = true;
      this.$store.state.langchange1 = true; //for footer
      this.$i18n.locale = lang;
      this.$router.replace({ params: { lang: this.$i18n.locale } })

      if (lang == "ar") {
        this.$store.state.UnitPrice = this.$store.state.unitAR

        document.documentElement.setAttribute("dir", "rtl");
        document.title = this.$store.state.title_ar;
        document.getElementById("description_meta").content = this.$store.state.description_ar;
        document.getElementById("keywords_meta").content = this.$store.state.keyword_ar;
        let h = document.querySelector('body');
        h.setAttribute('dir', 'rtl')
      } else {
        this.$store.state.UnitPrice = this.$store.state.unit

        document.documentElement.setAttribute("dir", "ltr");
        document.title = this.$store.state.title_en;
        document.getElementById("description_meta").content = this.$store.state.description_en;
        document.getElementById("keywords_meta").content = this.$store.state.keyword_en;

        let h = document.querySelector('body');
        h.setAttribute('dir', 'ltr')
      }
      this.loading = true;
      this.axios
        .get(
          this.$store.state.base_api_url +
          this.$store.storeName +
          "/sections_theme2",
          {
            headers: {
              "Accept-Language": this.$i18n.locale,
            },
          }
        )
        .then((response) => {
          this.headerSections = response.data.data;
        })
        .then(() => (this.loading = false));

      if (this.$localStorage.get(this.$store.storeName) != null) {
        this.loadingNote = true;
        this.axios
          .get(
            this.$store.state.base_api_url +
            this.$store.storeName +
            "/new_note",
            {
              headers: {
                "Accept-Language": this.$i18n.locale,
                Authorization:
                  "Bearer " + this.$localStorage.get(this.$store.storeName),
              },
            }
          )
          .then((response) => {
            if (response.data.data.code == "1") {
              this.notifications = response.data.data.notes;
              //console.log(this.notifications);
            }
          })
          .then(() => {
            this.loadingNote = false;
          });
      }

      this.axios
        .get(
          this.$store.state.base_api_url + this.$store.storeName + "/market_countries",
          {
            headers: {
              "Accept-Language": this.$i18n.locale
            }
          }
        )
        .then(response => {
          this.countries = response.data.data;
          console.log('gggg', this.countries)

        })
        .then(() => (this.loading = false));
    },
    logOut() {
      this.loading = true;
      this.axios.get(
        this.$store.state.base_api_url + this.$store.storeName + "/logout",
        {
          headers: {
            "Accept-Language": this.$i18n.locale,
            Authorization:
              "Bearer " + this.$localStorage.get(this.$store.storeName),
          },
        }
      );
      //console.group("hiiiiii")
      console.log(
        "logout:" +
        //this.$localStorage.id() +
        this.$localStorage.get(this.$store.storeName)
      );
      //this.$localStorage.remove("userToken");
      let AllCookies = this.$cookies.keys();
      for (let i = 0; i < AllCookies.length; i++) {
        if (AllCookies[i].split("/")[0] == this.$store.storeName) {
          this.$cookies.remove(console.log(AllCookies[i]));
        }
      }
      this.$cookies.keys().forEach(cookie => this.$cookies.remove(cookie))

      console.log(AllCookies);
      /*if (this.$cookies.isKey(this.$store.storeName + product.product_id + product.final_option + product.option_check)) {
      this.$cookies.remove(this.$store.storeName + product.product_id + product.final_option + product.option_check)
      }*/
      this.$localStorage.remove(this.$store.storeName);
      window.location.reload();
      this.loading = false;
    },
    searchRoute() {
      if (this.$route.path.includes("/" + this.$store.storeName + "/Search")) {
        console.log(this.word + "hiiiiiii");
        this.$router.push({ name: "search", params: { word: this.word, lang: this.$i18n.locale } });
      } else {
        this.$router.push({
          name: "search",
          params: { storeName: this.$store.storeName, word: this.word, lang: this.$i18n.locale },
        });
      }
    },
    deleteAll() {
      this.loadingNote = true;
      this.axios
        .get(
          this.$store.state.base_api_url +
          this.$store.storeName +
          "/delete_allnote",
          {
            headers: {
              "Accept-Language": this.$i18n.locale,
              Authorization:
                "Bearer " + this.$localStorage.get(this.$store.storeName),
            },
          }
        )
        .then((response) => {
          if (response.data.code == "1") {
            this.notifications = null;
            this.count = 0;
          }
        })
        .then(() => {
          this.loadingNote = false;
          this.show = false;
        });
    },
    deleteOneNote() {
      this.loading = true;
      this.axios
        .get(
          this.$store.state.base_api_url +
          this.$store.storeName +
          "/delete_note/" +
          this.deleteNoteId,
          {
            headers: {
              "Accept-Language": this.$i18n.locale,
              Authorization:
                "Bearer " + this.$localStorage.get(this.$store.storeName),
            },
          }
        )
        .then((response) => {
          if (response.data.code == "1") {
            this.$delete(this.notifications, this.deleteNoteIndex);

            // this.$el.parentNode.removeChild(this.$el);
          }
        })
        .then(() => {
          this.loading = false;
          this.show1 = false;
        });
    },
    deleteNote(itemId, itemIndex) {
      this.show1 = true;
      this.deleteNoteId = itemId;
      this.deleteNoteIndex = itemIndex;
    },
    /* onClickMobile: function () {
      $("#navbar").addClass(" navbar-mobile");
      $(".mobile-nav-toggle").addClass("bi-list bi-x");
    },*/
  },
};
</script>
